import { render, staticRenderFns } from "./VisitDetails.vue?vue&type=template&id=2a8c2d65"
import script from "./VisitDetails.vue?vue&type=script&lang=js"
export * from "./VisitDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports